module.exports = __webpack_public_path__ + "static/media/icon-new-message.b9165694.svg";